import React from "react";
import { Box, Stack } from "@mui/material";
import {
	CheckCircleOutlined,
	WarningAmberOutlined,
	CancelOutlined,
} from "@mui/icons-material";
import CustomCheckbox from "../custom-checkbox";
import styles from "./index.module.scss";

// item: { id, label, status: "pass"|"warn"|"fail", note }
const ROW_ICONS = {
	pass: <CheckCircleOutlined className={styles.iconPass} />,
	warn: <WarningAmberOutlined className={styles.iconWarn} />,
	fail: <CancelOutlined className={styles.iconFail} />,
};

const ChecklistRow = ({ item }) => (
	<Stack direction="row" alignItems="flex-start" className={styles.row}>
		<Box className={styles.iconCell}>{ROW_ICONS[item.status] || ROW_ICONS.fail}</Box>
		<Stack direction="column" flex={1}>
			<span className={styles.rowLabel}>{item.label}</span>
			{item.note && <span className={styles.rowNote}>{item.note}</span>}
		</Stack>
	</Stack>
);

const SubmissionChecklist = ({
	items,
	gateState,
	understandChecked,
	onUnderstandChange,
}) => {
	return (
		<Box className={styles.root}>
			<Stack direction="column" gap={0.5}>
				{items.map((item) => (
					<ChecklistRow key={item.id} item={item} />
				))}
			</Stack>

			{gateState === "amber" && (
				<Stack
					direction="row"
					alignItems="center"
					className={styles.understandRow}
					mt={2}
				>
					<CustomCheckbox
						id="understand-checkbox"
						checked={understandChecked}
						handleChange={(e) => onUnderstandChange(e.target.checked)}
						label=""
					/>
					<span className={styles.understandLabel}>
						I understand this loan has open items and I wish to submit anyway
					</span>
				</Stack>
			)}
		</Box>
	);
};

export default SubmissionChecklist;
